import {
  SET_LOADING,
  SET_CENTERED,
  SET_DARK_MODE,
  SET_LATEST_VERSION
} from './mutation-types'

const mutations = {
  [SET_CENTERED] (state, status) {
    state.centered = status
  },

  [SET_LOADING] (state, status) {
    state.loading = status
  },

  [SET_DARK_MODE] (state) {
    const darkMode = !state.darkMode

    localStorage.setItem('darkMode', darkMode)

    state.darkMode = darkMode
  },

  [SET_LATEST_VERSION] (state, version) {
    state.latestVersion = version
  }
}

export default mutations
